import { useState } from "react";
import { useDispatch } from "react-redux";
import { clearUser } from "@store/slices/userSlice";
import { resetConfig } from "@store/slices/configSlice";
import { clearCourseDetails } from "@store/slices/courseDetailsSlice";
import {
	resetMultiCourseFlow,
	clearSelectedCourses,
	clearAddedCourses,
	clearPreferences,
} from "@store/slices/courseSlice";
import { clearInstituteData } from "@store/slices/instituteSlice";
import { resetNotifications } from "@store/slices/notificationSlice";
import { resetCourses } from "@store/slices/dashboardCoursesSlice";
import { resetSignup } from "@store/slices/signupSlice";
import { clearAuthData } from "@utils/auth";
import { BROWSER_ROUTES } from "@constants/browser.routes";
import { resetUnauthorizedFlag } from "@config/axios/axios.config";
import { queryClient } from "@providers/QueryProvider";

export const useLogout = () => {
	const dispatch = useDispatch();
	const [showLogoutModal, setShowLogoutModal] = useState(false);

	const handleLogoutClick = () => {
		setShowLogoutModal(true);
	};

	const handleLogoutConfirm = () => {
		resetUnauthorizedFlag();

		// Clear all global states for fresh start
		dispatch(clearUser());
		dispatch(resetConfig());
		dispatch(clearCourseDetails());
		dispatch(resetMultiCourseFlow());
		dispatch(clearSelectedCourses());
		dispatch(clearAddedCourses());
		dispatch(clearPreferences()); // Clear course preferences
		dispatch(clearInstituteData());
		dispatch(resetNotifications());
		dispatch(resetCourses()); // Clear dashboard courses and reset persistence
		dispatch(resetSignup()); // Clear signup and admission form data

		// Clear React Query cache to prevent stale data for next user
		queryClient.clear();

		clearAuthData();
		setShowLogoutModal(false);
		// Full load to `/sign-in` only — `useNavigate()` was still leaving `?redirect=` on the URL (React Router 7).
		window.location.replace(`${window.location.origin}${BROWSER_ROUTES.LOGIN}`);
	};

	const handleLogoutCancel = () => {
		setShowLogoutModal(false);
	};

	return {
		handleLogout: handleLogoutClick,
		handleLogoutConfirm,
		handleLogoutCancel,
		showLogoutModal,
	};
};
